import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownButton } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import AutocompleteUserCcBcc from './AutocompleteUserCcBcc';
import UserEmailOption from './UserEmailOption';
import '../styles/listUserEmailOptions.less';
const PREVIEW_LIMIT_EMAIL = 3;
class ListUserEmailOptionsCcBcc extends Component {
    constructor(props) {
        super(props);
        this.onFocusFunction = () => {
            this.setState({ active: true });
        };
        this.onBlurFunction = () => {
            this.setState({ active: false });
        };
        this.state = {
            active: false,
        };
    }
    getDropdownContent(selectedOptions) {
        const { fields, fieldLabel } = this.props;
        return (_jsx("div", Object.assign({ className: "dropdown-content-wrapper" }, { children: selectedOptions
                .filter((contactField) => typeof contactField.email === 'string')
                .map((contactField, index) => {
                if (PREVIEW_LIMIT_EMAIL <= index) {
                    return (_jsx(UserEmailOption, { removable: true, fieldLabel: fieldLabel, contactField: contactField, fields: fields, index: index, change: this.props.change }, `cc-bcc-extra-${contactField.email}-${index}`));
                }
                return null;
            })
                .filter((q) => q !== undefined) })));
    }
    render() {
        const { fields, fieldLabel, showSearch, meta: { touched, submitFailed, error, valid, form, pristine }, availableOptions, singleChoice, touch, className, placeholder, } = this.props;
        const hasError = (touched || submitFailed) && error ? 'has-error' : '';
        const hasSuccess = valid && pristine === false ? 'has-success' : '';
        let isSearchShown = true;
        const selectedOptions = [];
        let noneFoundMessage = 'None found';
        let formGroupClasses = className && typeof className === 'string' ? className : '';
        fields.map((field, index) => {
            const f = fields.get(index);
            selectedOptions.push(f.user);
        });
        let filteredFields = availableOptions.map((x) => Object.assign(x, selectedOptions.find((y) => y.id == x.id)));
        if (selectedOptions.length > 0 && singleChoice === true) {
            filteredFields = [];
            isSearchShown = false;
            noneFoundMessage =
                'Only a single choice can be selected. Remove the selected choice if you want another.';
        }
        if (availableOptions === null) {
            filteredFields = [];
        }
        if (this.state.active === true) {
            formGroupClasses += ' focused';
        }
        if (singleChoice === true) {
            formGroupClasses += ' single-choice';
        }
        return (_jsxs("div", Object.assign({ className: `list-user-options-fields user-options-styled-cc-bcc ${formGroupClasses} ${hasSuccess} ${hasError}` }, { children: [selectedOptions.map((contactField, index) => {
                    if (index < PREVIEW_LIMIT_EMAIL) {
                        return (_jsx(UserEmailOption, { removable: true, fieldLabel: fieldLabel, contactField: contactField, fields: fields, index: index, change: this.props.change }, `cc-bcc-${contactField.email}-${index}`));
                    }
                    return null;
                }), selectedOptions.length > PREVIEW_LIMIT_EMAIL && (_jsx(DropdownButton, Object.assign({ noArrow: true, noStyle: true, dropdown: this.getDropdownContent(selectedOptions), className: "dropdown-extra-cc-bcc-wrapper" }, { children: `+${selectedOptions.length - PREVIEW_LIMIT_EMAIL} more...` }))), showSearch && (_jsx(AutocompleteUserCcBcc, { touch: touch, stopFormSubmit: this.props.stopFormSubmit, isShown: isSearchShown, formName: form, fieldLabel: fieldLabel, noneFoundMessage: noneFoundMessage, getfunction: this.props.getfunction, placeholder: placeholder, elements: filteredFields, ElementItem: this.props.elementItem, onFocusFunction: this.onFocusFunction, onBlurFunction: this.onBlurFunction, status: this.props.status, add: fields.push, error: fields.error, fields: fields }))] })));
    }
}
export default ListUserEmailOptionsCcBcc;
